<template>
  <div id="Password" class="wrap">
    <van-nav-bar z-index="10" fixed placeholder :title="$t('My.PersonalInformation.Password.title')" left-arrow
      @click-left="onClickLeft" />
    <div class="login-password-content">
      <van-form ref="passwordForm" :disabled="loading" validate-first validate-trigger="onSubmit" @submit="submit">
        <div class="password-fields">
          <van-field v-model="formData.oldpass" name="oldpass" :label="$t('password.old')"
            :placeholder="$t('password.old.placeholder')" :rules="formRules.oldpass" />
          <van-field v-model="formData.newpass" name="newpass" :label="$t('password.new')"
            :placeholder="$t('password.new.placeholder')" :rules="formRules.newpass" />
          <van-field v-model="formData.confirmpass" name="confirmpass" :label="$t('password.confirmPassword')"
            :placeholder="$t('password.confirmPassword.placeholder')" :rules="formRules.confirmpass" />
        </div>
        <div class="button-confirm">
          <van-button class="login-password-submit" block native-type="submit" :loading="loading" :disabled="loading">
            {{ $t('My.PersonalInformation.Password.Button') }}
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { Button, Field, Form, NavBar, Toast } from "vant";

export default {
  name: "Password",
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Form.name]: Form,
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      loading: false,
      formData: {
        oldpass: "",
        newpass: "",
        confirmpass: "",
      },
    };
  },
  computed: {
    formRules() {
      return {
        oldpass: [
          {
            required: true,
            validator: this.isNotBlank,
            message: this.$t("password.old.placeholder"),
          },
        ],
        newpass: [
          {
            required: true,
            validator: this.isNotBlank,
            message: this.$t("password.new.placeholder"),
          },
        ],
        confirmpass: [
          {
            required: true,
            validator: this.isNotBlank,
            message: this.$t("password.confirmPassword.placeholder"),
          },
          {
            validator: (value) => value === this.formData.newpass,
            message: this.$t("hint.passwordDiff"),
          },
        ],
      };
    },
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    isNotBlank(value) {
      return typeof value === "string" && value.trim().length > 0;
    },
    async submit() {
      if (this.loading) return;

      return this.$submitOnce("login-password", async () => {
        try {
          await this.$refs.passwordForm.validate();
        } catch (errors) {
          return;
        }

        this.loading = true;
        try {
          await new Promise((resolve, reject) => {
            this.$api.editPwd(
              {
                oldpass: this.formData.oldpass,
                newpass: this.formData.newpass,
              },
              resolve,
              reject
            );
          });

          Toast(this.$t("Hint.success"));
          await new Promise((resolve) => setTimeout(resolve, 800));
          await this.$router.replace({ name: "login" });
        } catch (error) {
          Toast(this.$t("Hint.failed"));
        } finally {
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
#Password {
  width: 100%;
  min-height: 100vh;
  background: var(--page-background);

  .login-password-content {
    padding: calc(16rem / 16) calc(16rem / 16) calc(32rem / 16);
  }

  .password-fields {
    overflow: hidden;
    border-radius: calc(10rem / 16);
    background: #fff;
  }

  /deep/ .van-field {
    display: block;
    padding: calc(15rem / 16) calc(16rem / 16);
  }

  /deep/ .van-field__label {
    width: auto;
    margin: 0 0 calc(8rem / 16);
    color: #333;
    font-size: calc(14rem / 16);
    line-height: 1.5;
  }

  /deep/ .van-field__value {
    width: 100%;
  }

  /deep/ .van-field__control {
    font-size: calc(14rem / 16);
    line-height: 1.6;
  }

  /deep/ .van-field__error-message {
    margin-top: calc(5rem / 16);
    line-height: 1.5;
  }

  .button-confirm {
    margin-top: calc(24rem / 16);
  }

  .login-password-submit {
    height: auto;
    padding: calc(13rem / 16) calc(16rem / 16);
    border: 0;
    border-radius: calc(8rem / 16);
    background: var(--button-background);
    color: var(--button-text);
    font-size: calc(16rem / 16);
    line-height: 1.5;
  }
}
</style>
